module.exports = __webpack_public_path__ + "img/Banner-RenderedLoops.a27341f8.jpg";